import { Box, Breadcrumbs, Button, CircularProgress, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, InputLabel, MenuItem, Pagination, Select, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from "@mui/material";
import React, {  useState } from "react";
import { MdNavigateNext } from "react-icons/md";
import { Link } from "react-router-dom";
import axios from "axios";
import {  VERIFY_MATCH } from "../../constant/endpoint";
import { useStyles } from "../../constant/constant";
import { getSweetAlert } from "../../helper";

const MatchVerifier = () => {
    const classes = useStyles();
    const [matchId, setMatchId] = useState("")
    const [result, setResult] = useState("")
    const [loading, setLoading] = React.useState(false);

    const breadcrumbs = [
        <Link underline="hover" key="1" color="inherit" to={''} >
            <h4>Prediction</h4>
        </Link>, <Link
            underline="hover"
            color="inherit"
        >
            Match Verifier
        </Link>
    ];

    const handleChange = (event) => {
        setMatchId(event.target.value)
    }
    const submitHandle = async () => {
        if (!matchId) {
            getSweetAlert("error", "Please Enter Match Id")
            return;
        }
        setLoading(true)
        const getVerifierData = await axios.get(VERIFY_MATCH.replace("matchId", matchId))
        setLoading(false)
     if (getVerifierData?.data?.status === 'success') {
         setResult(getVerifierData?.data?.data)
         console.log("getVerifierData?.data?.data", getVerifierData?.data?.data);
         
         if (getVerifierData?.data?.data.length === 0) {
            getSweetAlert("info", "All Verifiers are OK")
         }
     }
    }
    return (
        <>
            {loading ? <Box
                sx={{
                    position: 'fixed',
                    top: 0,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    zIndex: 9999, // Ensure it stays above other elements
                    paddingTop: '20%', // Space from top of the page
                }}
            >
                <CircularProgress />
            </Box> : ""}
            <div className="homeCard">
                <div className='subHomeCard'>
                    <Breadcrumbs
                        separator={<MdNavigateNext fontSize="small" />}
                        aria-label="breadcrumb"
                    >

                        {breadcrumbs}
                    </Breadcrumbs>
                    <div>
                        <Container maxWidth="xl">
                            <Grid container spacing={2} style={{ marginBottom: "20px" }}>
                                <Grid item xs={4}>
                                    <InputLabel id="demo-simple-select-label">Match Id</InputLabel>
                                    <TextField type="number" id="outlined-basic"  variant="outlined" style={{ width: "100%" }} placeholder="Enter Match Id" name={'matchId'} onChange={handleChange}/>
                                </Grid>
                                <Grid item xs={4} style={{ margin: "auto" }}>
                                    <Button variant={'contained'} color={'primary'} onClick={submitHandle}>Submit</Button>
                                </Grid>
                               
                            </Grid>
                        </Container>
                        {

                            result.length > 0 ?
                                <>
                                <Container maxWidth="xl">
                                    <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                            <TableContainer >
                                                <Table className={classes.table}>
                                                    <TableHead>
                                                        <TableRow>
                                                                <TableCell align="left">S.No</TableCell>
                                                                <TableCell align="left">Joined Id</TableCell>
                                                                <TableCell align="left">Cancel Slot Verifier</TableCell>
                                                                <TableCell align="left">Sold Slot Verifier</TableCell>
                                                                <TableCell align="left">Incoming Verifier</TableCell>
                                                          
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {result?.map((row,index) => (
                                                            <TableRow
                                                                key={row.name}
                                                                style={{ marginTop: "10px" }}
                                                            >
                                                                <TableCell align="left">{index + 1}</TableCell>
                                                                <TableCell align="left">{row._id}</TableCell>
                                                                <TableCell align="left">{row.cancelVerifier === false ? "FALSE" : "TRUE"}</TableCell>
                                                                <TableCell align="left">{row.soldVerifier  === false ? "FALSE" : "TRUE"}</TableCell>
                                                                <TableCell align="left">{row.incomingVerifier  === false ? "FALSE" : "TRUE"}</TableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Grid>
                                    </Grid>
                                    </Container>
                                </> :
                                <>
                                    {
                                        loading ? <></> :
                                <Table>
                                    <TableRow>
                                        <h3 style={{ textAlign: "center" }}>No Data Found</h3>
                                    </TableRow>
                                </Table>
                                    }
                                    </>
                        }
                    </div>
                </div>
 
            </div>
        </>
    )
}
export default MatchVerifier